export default __webpack_public_path__ + "static/media/icon-thumb-up.21e02b94.svg";